import { ButtonHTMLAttributes, ReactNode } from "react";
import { clsx } from "clsx";

type Variant = "primary" | "outline" | "ghost" | "danger";

export function Button({ className, children, variant = "ghost", size = "md", leftIcon, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: "sm" | "md" | "lg"; leftIcon?: ReactNode }) {
  return (
    <button
      className={clsx(
        "inline-flex items-center justify-center gap-2 rounded-md font-medium transition focus-visible:ring-2 focus-visible:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-50",
        size === "sm" && "h-8 px-2.5 text-xs",
        size === "md" && "h-9 px-3 text-sm",
        size === "lg" && "h-10 px-4 text-sm",
        variant === "primary" && "bg-brand-500 text-white shadow-sm hover:bg-brand-600",
        variant === "outline" && "border border-border bg-card text-text hover:bg-hover dark:border-border-dark dark:bg-card-dark dark:text-text-dark dark:hover:bg-hover-dark",
        variant === "ghost" && "text-muted hover:bg-hover hover:text-text dark:text-muted-dark dark:hover:bg-hover-dark dark:hover:text-text-dark",
        variant === "danger" && "bg-danger-500 text-white hover:bg-danger-600",
        className,
      )}
      {...props}
    >
      {leftIcon}
      {children}
    </button>
  );
}
